export type AnalyticsConsent = 'granted' | 'denied'

export const ANALYTICS_CONSENT_KEY = 'vvtable.analytics-consent.v1'
export const ANALYTICS_SCRIPT_ID = 'vvtable-google-analytics'
const MEASUREMENT_ID = 'G-XQ5E9V1SMC'

declare global {
	interface Window {
		dataLayer?: unknown[]
		gtag?: (...args: unknown[]) => void
		'ga-disable-G-XQ5E9V1SMC'?: boolean
	}
}

export function readAnalyticsConsent(): AnalyticsConsent | null {
	try {
		const value = window.localStorage.getItem(ANALYTICS_CONSENT_KEY)
		return value === 'granted' || value === 'denied' ? value : null
	} catch {
		return null
	}
}

function removeAnalyticsCookies() {
	const names = document.cookie.split(';').map(cookie => cookie.trim().split('=')[0])
	const labels = window.location.hostname.split('.')
	const domains = labels.slice(0, -1).map((_, index) => labels.slice(index).join('.'))

	for (const name of names.filter(name => /^_ga(?:_|$)|^_gid$|^_gat(?:_|$)/.test(name))) {
		const expired = `${name}=; Max-Age=0; Path=/; SameSite=Lax`
		document.cookie = expired
		for (const domain of domains) document.cookie = `${expired}; Domain=${domain}`
	}
}

export function applyAnalyticsConsent(consent: AnalyticsConsent | null) {
	window['ga-disable-G-XQ5E9V1SMC'] = consent !== 'granted'
	if (consent !== 'granted') {
		removeAnalyticsCookies()
		return
	}

	// До согласия не загружаем даже библиотеку Google: запросов к ней быть не должно.
	if (document.getElementById(ANALYTICS_SCRIPT_ID)) return
	window.dataLayer = window.dataLayer || []
	window.gtag = function () {
		window.dataLayer?.push(arguments)
	}
	window.gtag('js', new Date())
	window.gtag('config', MEASUREMENT_ID, {
		allow_google_signals: false,
		allow_ad_personalization_signals: false,
	})

	const script = document.createElement('script')
	script.id = ANALYTICS_SCRIPT_ID
	script.async = true
	script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`
	document.head.appendChild(script)
}

export function saveAnalyticsConsent(consent: AnalyticsConsent) {
	// Выбор действует и при недоступном хранилище; тогда он сохраняется только до перезагрузки.
	applyAnalyticsConsent(consent)
	try {
		window.localStorage.setItem(ANALYTICS_CONSENT_KEY, consent)
	} catch {
		// Закрытый доступ к localStorage не должен включать аналитику без выбора пользователя.
	}
}
